import React from 'react'
import CardItem from './CardItem'
import './Cards.css'

function CardsProduct() {
  return (
    <div className='cards'>
      
      <div className='cards__container'>
        <div className='cards_wrapper'>
            <ul className='cards_items'>
            <CardItem 
                src="images/sea.jpg"
                label='Sea'
                path='https://www.cgtrader.com/3d-models/exterior/landscape/sea-with-realistic-waves-and-rain'
                text="Try OUR SEA MODEL now!"
                />
                <CardItem 
                src="images/body.jpg"
                label='Hair'
                path='https://www.cgtrader.com/3d-models/character/man/upper-human-body-with-colored-hair'
                text="Try BLENDER HAIR MODEL now!"
                />
                <CardItem 
                src="images/lightning.jpg"
                label='Lightning'
                path='https://www.cgtrader.com/3d-models/exterior/landscape/animated-lightning-with-sound-effect'
                text="Try ANIMATED LIGHTNING now!"
                />
            </ul>
        </div>
        </div>

    </div>
  )
}

export default CardsProduct
